import React from "react";
import { SkeletonBlock, SkeletonText } from "./Skeleton";

/**
 * Card-grid skeleton for the league screens (Find Leagues, My Leagues, Cash
 * Leagues) and any other tile grid.
 *
 * Each tile is a real card outline with a cover rectangle, a title line and two
 * meta lines. The Join button is NOT drawn — a grey rectangle where a button
 * belongs invites a tap.
 *
 * The caller's grid classes lay these out, so the skeleton inherits the exact
 * column count and gaps and the grid can't reflow when the real cards land.
 */
const CardGridSkeleton = ({ cards = 5, coverHeight = 132 }) => (
  <>
    {Array.from({ length: cards }).map((_, i) => (
      <div
        key={i}
        aria-hidden="true"
        className="rounded-xl border border-gray-200 bg-white overflow-hidden"
      >
        <SkeletonBlock height={coverHeight} rounded="rounded-none" />
        <div className="p-4">
          <SkeletonBlock height={15} width="72%" />
          <SkeletonText
            lines={2}
            height={11}
            lastLineWidth="48%"
            className="mt-3"
          />
        </div>
      </div>
    ))}
  </>
);

export default CardGridSkeleton;
